const WRAPPER_SELECTOR = '[data-component="product-tabs"]';
const TRIGGER_SELECTOR = '[data-product-tab-trigger]';
const PANEL_SELECTOR = '[data-product-tab-panel]';
const ITEM_SELECTOR = '[data-product-tab-item]';

const NAV_KEYS = new Set(['ArrowDown', 'ArrowUp', 'Home', 'End']);

const getAccordionState = (component) => ({
    items: Array.from(component.querySelectorAll(ITEM_SELECTOR)),
    triggers: Array.from(component.querySelectorAll(TRIGGER_SELECTOR)),
    panels: Array.from(component.querySelectorAll(PANEL_SELECTOR)),
});

const setExpandedState = (state, index, expanded) => {
    const trigger = state.triggers[index];
    const panel = state.panels[index];
    const item = state.items[index];

    if (!trigger || !panel || !item) {
        return;
    }

    trigger.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    item.classList.toggle('is-open', expanded);
};

const closeAllItems = (state) => {
    state.items.forEach((_, index) => {
        setExpandedState(state, index, false);
    });
};

const toggleItem = (state, index) => {
    const trigger = state.triggers[index];

    if (!trigger) {
        return;
    }

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    closeAllItems(state);
    if (!isOpen) {
        setExpandedState(state, index, true);
    }
};

const getNextFocusIndex = (key, currentIndex, lastIndex) => {
    switch (key) {
        case 'ArrowDown':
            return currentIndex === lastIndex ? 0 : currentIndex + 1;
        case 'ArrowUp':
            return currentIndex === 0 ? lastIndex : currentIndex - 1;
        case 'Home':
            return 0;
        case 'End':
            return lastIndex;
        default:
            return currentIndex;
    }
};

const bindAccordion = (component) => {
    const state = getAccordionState(component);
    const { triggers, panels } = state;

    if (!triggers.length || triggers.length !== panels.length) {
        return;
    }

    closeAllItems(state);

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
            toggleItem(state, index);
        });

        trigger.addEventListener('keydown', (event) => {
            if (!NAV_KEYS.has(event.key)) {
                return;
            }

            event.preventDefault();
            const nextIndex = getNextFocusIndex(event.key, index, triggers.length - 1);
            triggers[nextIndex].focus();
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll(WRAPPER_SELECTOR);

    accordions.forEach(bindAccordion);
});
